export {
  validateVersions,
  validateDocuments,
  validateLinks,
  validateKlauseln,
  validateAlternativeTexte,
  validateEingabekriterien,
  validateEingabestruktur,
  validateTextblocks
};

const basePathEditon = "Edition -> ";
const basePathMindestlohn = "Mindestlohn-Konfiguration -> ";

function getErrorObject(language, valuePath, value, id) {
  return {
    id: id,
    value: value,
    language: language,
    valuePath: valuePath,
    errorMsg: "Fehlnder Wert in ( " + valuePath + " ) in der Sprache ( " + language + " )"
  };
}

function validateVersions(versionContents) {
  const errorObject = [];
  const newVersionsObject = JSON.parse(JSON.stringify(versionContents));
  const indexesToRemove = [];

  //Wird Benötigt für die Visuelle Validierung im Frontend
  const validationObject = JSON.parse(JSON.stringify(versionContents));

  let iterationCounter = 0;
  versionContents.forEach((content, index) => {
    //Überprüfung ob alle nötigen Werte vorhanden sind
    if (!content.nameShort) {
      errorObject.push(getErrorObject(content.language, "Version -> Kurzname", content.nameShort, content.id));
      validationObject[index].valid_nameShort = false;

      delete content["nameShort"];
    } else {
      validationObject[index].valid_nameShort = true;
    }

    if (!content.value) {
      errorObject.push(getErrorObject(content.language, "Version -> Name des Vertrags", content.value, content.id));

      validationObject[index].valid_value = false;

      delete content["value"];
    } else {
      validationObject[index].valid_value = true;
    }

    if (!content.nameShort && !content.value && content.id == 0) {
      indexesToRemove.push(index);
    }

    if ("valid_nameShort" in content) {
      delete content["valid_nameShort"];
    }

    if ("valid_value" in content) {
      delete content["valid_value"];
    }
    iterationCounter++;
  });

  if (iterationCounter == versionContents.length) {
    const filtered = newVersionsObject.filter((value, index) => {
      return !indexesToRemove.includes(index);
    });

    return {
      validationObject: validationObject,
      originalObject: versionContents,
      errorObject: errorObject,
      newVersionsObject: filtered
    };
  }
}

function validateDocuments(documentsObject) {
  const errorObject = [];

  let basePath = basePathEditon + "Anlagen Dokumente -> ";
  let iterationCounter = 0;

  documentsObject.forEach((document, documentIndex) => {
    const valideContentObjects = [];
    let contentCounter = 0;
    document.contents.forEach((content) => {
      if (!content.value) {
        errorObject.push(getErrorObject(content.language, basePath + document.code, content.value, content.id));
      } else {
        valideContentObjects.push(content);
      }
      contentCounter++;
    });

    if (contentCounter == document.contents.length) {
      documentsObject[documentIndex].contents = valideContentObjects;

      iterationCounter++;
    }
  });

  if (iterationCounter == documentsObject.length) {
    return {
      originalObject: documentsObject,
      errorObject: errorObject
    };
  }
}

function validateLinks(linksObject) {
  const errorObject = [];
  let basePath = basePathEditon + "Links -> ";
  let iterationCounter = 0;

  //Wird Benötigt für die Visuelle Validierung im Frontend
  const validationObject = JSON.parse(JSON.stringify(linksObject));

  linksObject.forEach((linkObject, index) => {
    //Das Validierte Object, welche am Backend übergeben wird, ohne leere Einträge
    const valideContentObjects = [];
    //Validiertes Object für die Visuelle Darstellung im Fronten
    const validationObjectContents = [];

    let contentCounter = 0;
    let errorCounter = 0;
    linkObject.contents.forEach((content) => {
      if (!content.value || !content.url) {
        errorObject.push(getErrorObject(content.language, basePath + linkObject.code, content.value, content.id));
        content.valid_value = false;
        validationObjectContents.push(content);
        errorCounter++;
      } else {
        valideContentObjects.push(content);
        content.valid_value = true;
        validationObjectContents.push(content);
      }

      if ("valid_value" in content) {
        delete content["valid_value"];
      }

      contentCounter++;
    });
    if (contentCounter == linkObject.contents.length) {
      linksObject[index].contents = valideContentObjects;
      validationObject[index].contents = validationObjectContents;
      if (errorCounter) {
        validationObject[index].valid_value = false;
      } else {
        validationObject[index].valid_value = true;
      }

      if ("valid_value" in linksObject[index]) {
        delete linksObject[index]["valid_value"];
      }

      iterationCounter++;
    }
  });

  if (iterationCounter == linksObject.length) {
    return {
      validationObject: validationObject,
      originalObject: linksObject,
      errorObject: errorObject
    };
  }
}

function validateKlauseln(klauselnObject, allCriterionConfiguration, translatedToLanguages) {
  const errorObject = [];
  let basePath = basePathEditon + "Klauseln -> ";
  let iterationCounter = 0;
  const newKlauselObject = JSON.parse(JSON.stringify(klauselnObject));

  const indexesToRemove = [];

  klauselnObject.forEach((klausel, index) => {
    const valideContentObjects = [];

    let contentCounter = 0;

    if (!klausel.klauselContents.length) {
      indexesToRemove.push(index);
      delete klausel["klauselContents"];
    } else {
      let counterErrorContens = 0;
      let tempErrorObject = [];

      let errorCounter = 0;

      klausel.klauselContents.forEach((content, j) => {
        if (!content.value || !/\S/.test(content.value)) {
          newKlauselObject[index].klauselContents[j].valid_value = false;
          errorCounter++;
          if (klausel.usePVL || klausel.useGB) {
            counterErrorContens++;

            tempErrorObject.push(
              getErrorObject(
                content.language,
                basePath + getKlauselName(klausel, allCriterionConfiguration),
                content.value,
                content.id
              )
            );
          } else {
            errorObject.push(
              getErrorObject(
                content.language,
                basePath + getKlauselName(klausel, allCriterionConfiguration),
                content.value,
                content.id
              )
            );
          }
        } else {
          newKlauselObject[index].klauselContents[j].valid_value = true;
          newKlauselObject[index].klauselContents[j].klauselPath = getKlauselPath(klausel, allCriterionConfiguration);
          valideContentObjects.push(content);
        }
        if ("valid_value" in content) {
          delete content["valid_value"];
        }
        contentCounter++;
      });

      if (contentCounter == klausel.klauselContents.length) {
        if (counterErrorContens >= translatedToLanguages.length) {
          indexesToRemove.push(index);
        } else if (klausel.usePVL || klausel.useGB) {
          if (tempErrorObject.length) {
            errorObject.push(...tempErrorObject);
          }
        }

        if ("valid_value" in klauselnObject[index]) {
          delete klauselnObject[index]["valid_value"];
        }

        if (errorCounter) {
          newKlauselObject[index].valid_value = false;
        } else {
          newKlauselObject[index].valid_value = true;
        }

        klauselnObject[index].klauselContents = valideContentObjects;
      }
    }

    iterationCounter++;
  });

  if (iterationCounter == klauselnObject.length) {
    const filtered = newKlauselObject.filter((value, index) => {
      return !indexesToRemove.includes(index);
    });

    return {
      originalObject: klauselnObject,
      errorObject: errorObject,
      newKlauselObject: filtered
    };
  }
}

function getKlauselName(klausel, allCriterionConfiguration) {
  return allCriterionConfiguration.find(
    (criterionConfiguration) => klausel.klauselTypId == criterionConfiguration.klauselTypeId
  ).value;
}

function getKlauselPath(klausel, allCriterionConfiguration) {
  return allCriterionConfiguration.find(
    (criterionConfiguration) => klausel.klauselTypId == criterionConfiguration.klauselTypeId
  ).path;
}

function validateAlternativeTexte(alternativTextsToTranslate) {
  const errorObject = [];
  let basePath = basePathMindestlohn + "Alternativtexte -> ";
  let iterationCounter = 0;

  //Validiertes Object für die Visuelle Darstellung im Fronten
  const validationObject = JSON.parse(JSON.stringify(alternativTextsToTranslate));

  alternativTextsToTranslate.forEach((alternativText, index) => {
    //Das Validierte Object, welche am Backend übergeben wird, ohne leere Einträge
    const valideContentObjects = [];

    let contentCounter = 0;
    let errorCounter = 0;
    if (alternativText.contents.length) {
      alternativText.contents.forEach((content, j) => {
        if (!content.text) {
          errorObject.push(getErrorObject(content.language, basePath + (index + 1), content.text, content.id));
          validationObject[index].contents[j].valid_value = false;
          errorCounter++;
        } else {
          valideContentObjects.push(content);
          validationObject[index].contents[j].valid_value = true;
        }
        if ("valid_value" in content) {
          delete content["valid_value"];
        }

        contentCounter++;
      });

      if (contentCounter == alternativText.contents.length) {
        alternativTextsToTranslate[index].contents = valideContentObjects;

        if ("valid_value" in alternativTextsToTranslate[index]) {
          delete alternativTextsToTranslate[index]["valid_value"];
        }

        if (errorCounter) {
          validationObject[index].valid_value = false;
        } else {
          validationObject[index].valid_value = true;
        }
      }
    } else {
      delete alternativText["contents"];
    }
    iterationCounter++;
  });

  if (iterationCounter == alternativTextsToTranslate.length) {
    return {
      validationObject: validationObject,
      originalObject: alternativTextsToTranslate,
      errorObject: errorObject
    };
  }
}

function validateEingabekriterien(eingabekriterienObject) {
  const errorObject = [];
  let basePath = basePathMindestlohn + "Kriterien Eingabekriterien -> ";
  let iterationCounter = 0;

  //Validiertes Object für die Visuelle Darstellung im Fronten
  const validationObject = JSON.parse(JSON.stringify(eingabekriterienObject));

  eingabekriterienObject.forEach((eingabekriterium, index) => {
    const valideContentObjects = [];
    let contentCounter = 0;
    let errorCounter = 0;
    if (eingabekriterium.contents.length) {
      eingabekriterium.contents.forEach((content, j) => {
        if (!content.text) {
          errorObject.push(
            getErrorObject(content.language, basePath + eingabekriterium.code, content.text, content.id)
          );
          validationObject[index].contents[j].valid_value = false;
          errorCounter++;
        } else {
          valideContentObjects.push(content);
          validationObject[index].contents[j].valid_value = true;
        }
        if ("valid_value" in content) {
          delete content["valid_value"];
        }

        contentCounter++;
      });

      if (contentCounter == eingabekriterium.contents.length) {
        eingabekriterienObject[index].contents = valideContentObjects;

        if ("valid_value" in eingabekriterienObject[index]) {
          delete eingabekriterienObject[index]["valid_value"];
        }

        if (errorCounter) {
          validationObject[index].valid_value = false;
        } else {
          validationObject[index].valid_value = true;
        }
      }
    } else {
      delete eingabekriterium["contents"];
    }
    iterationCounter++;
  });

  if (iterationCounter == eingabekriterienObject.length) {
    return {
      validationObject: validationObject,
      originalObject: eingabekriterienObject,
      errorObject: errorObject
    };
  }
}

function validateEingabestruktur(eingabeStukturenObject) {
  const errorObject = [];
  let basePath = basePathMindestlohn + "Kriterien Struktur -> ";
  let iterationCounter = 0;

  //Validiertes Object für die Visuelle Darstellung im Fronten
  const validationObject = JSON.parse(JSON.stringify(eingabeStukturenObject));

  eingabeStukturenObject.forEach((eingabeStuktur, index) => {
    const valideContentObjects = [];
    let contentCounter = 0;
    let errorCounter = 0;
    if (eingabeStuktur.contents.length) {
      eingabeStuktur.contents.forEach((content, j) => {
        if (!content.value) {
          errorObject.push(getErrorObject(content.language, basePath + eingabeStuktur.code, content.value, content.id));
          validationObject[index].contents[j].valid_value = false;
          errorCounter++;
        } else {
          valideContentObjects.push(content);
          validationObject[index].contents[j].valid_value = true;
        }

        if ("valid_value" in content) {
          delete content["valid_value"];
        }
        contentCounter++;
      });

      if (contentCounter == eingabeStuktur.contents.length) {
        eingabeStukturenObject[index].contents = valideContentObjects;

        if ("valid_value" in eingabeStukturenObject[index]) {
          delete eingabeStukturenObject[index]["valid_value"];
        }

        if (errorCounter) {
          validationObject[index].valid_value = false;
        } else {
          validationObject[index].valid_value = true;
        }
      }
    } else {
      delete eingabeStuktur["contents"];
    }
    iterationCounter++;
  });

  if (iterationCounter == eingabeStukturenObject.length) {
    return {
      validationObject: validationObject,
      originalObject: eingabeStukturenObject,
      errorObject: errorObject
    };
  }
}

function validateTextblocks(textblocksObject) {
  const errorObject = [];
  let basePath = basePathMindestlohn + "Textblöcke -> ";
  let iterationCounter = 0;
  //Validiertes Object für die Visuelle Darstellung im Fronten
  const validationObject = JSON.parse(JSON.stringify(textblocksObject));

  textblocksObject.forEach((textblock, index) => {
    const valideContentObjects = [];
    let contentCounter = 0;
    let errorCounter = 0;
    if (textblock.contents.length) {
      textblock.contents.forEach((content, j) => {
        if (!content.text && textblock.type == 3) {
          errorObject.push(
            getErrorObject(content.language, basePath + "Zusätzlicher Text " + textblock.code, content.text, content.id)
          );
          validationObject[index].contents[j].valid_value = false;
          errorCounter++;
        } else if (!content.text && textblock.type == 2) {
          errorObject.push(
            getErrorObject(content.language, basePath + "Fussnote " + textblock.code, content.text, content.id)
          );
          validationObject[index].contents[j].valid_value = false;
          errorCounter++;
        } else if (textblock.type == 1) {
          if (!content.description && !content.text) {
            errorObject.push(
              getErrorObject(
                content.language,
                basePath + " ' Text in 2.Spalte ' oder ' Text hinter Titel ' muss vorhanden sein ",
                content.description,
                content.id
              )
            );
            validationObject[index].contents[j].valid_value = false;
            errorCounter++;
          }

          if (content.description || content.text) {
            if (!content.value) {
              content.value = "de";
            }
            valideContentObjects.push(content);
            validationObject[index].contents[j].valid_value = true;
          }
        } else {
          valideContentObjects.push(content);
          validationObject[index].contents[j].valid_value = true;
        }
        if ("valid_value" in content) {
          delete content["valid_value"];
        }
        contentCounter++;
      });

      if (contentCounter == textblock.contents.length) {
        textblocksObject[index].contents = valideContentObjects;

        if ("valid_value" in textblocksObject[index]) {
          delete textblocksObject[index]["valid_value"];
        }

        if (errorCounter) {
          validationObject[index].valid_value = false;
        } else {
          validationObject[index].valid_value = true;
        }
      }
    } else {
      delete textblock["contents"];
    }
    iterationCounter++;
  });

  if (iterationCounter == textblocksObject.length) {
    return {
      validationObject: validationObject,
      originalObject: textblocksObject,
      errorObject: errorObject
    };
  }
}
